import { sspApi } from '_utils/network';
import { Ssid } from '_types/ssid';
export function fetchSsids(): Promise<[Ssid]> {
  return sspApi.get('ssids').then(res => {
    if (res.status !== 200) throw new Error('failed');
    return res.json();
  });
}
